import PropTypes from 'prop-types';
import {
  ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider, responsiveFontSizes
} from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

// eslint-disable-next-line import/no-mutable-exports
export let theme = createTheme({
  palette: {
    common: {
      black: '#404040',
      lightBlack: '#3B3B3B',
      darkGrey: '#5D5D5D',
      grey: '#707070'
    },
    primary: {
      main: '#16497B',
      dark: '#07406B',
      light: '#0160A8'
    },
    background: {
      default: '#F2F2F2',
    },
    warning: {
      main: '#F38B3C',
    },
    error: {
      main: '#AB2626'
    },
    grey: {
      100: '#00000029',
      900: '#0D354D'
    }
  },
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    }
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 14,
    fontFamily: [
      'Open Sans', 'sans-serif'].join(','),
    h1: {
      fontSize: '3rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.7rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.3rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1.125rem',
      color: '#5D5D5D',
    },
    body2: {
      fontSize: '0.875rem',
      color: '#707070'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: '0px 2px 10px #00000069',
          minWidth: '12.5rem',
          padding: '6px 38px',
          borderRadius: '0.625rem',
          fontWeight: 300,
          textTransform: 'capitalize'
        },
      }
    },
    MuiGrid: {
      styleOverrides: {
        container: {
          marginTop: '0 !important'
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          backgroundColor: 'rgb(255 202 202)'
        }
      }
    }
  }
});

theme = responsiveFontSizes(theme);
export default function ThemeProvider({ children }) {
  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.element,
};

ThemeProvider.defaultProps = {
  children: null
};
